import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/forgotten-password')({
  beforeLoad: () => {
    throw redirect({ to: '/mot-de-passe-oublie', replace: true })
  },
})
